<ng-container *ngFor="let addOn of sortingAddons">
  <ng-container *ngIf="addOn.addonType === ADDONS_TYPES.PRINTING_PICTURE">
    <cake-motive-section
      class="d-block border-for-build-section"
      [disabled]="!cartLine.variant && !isPiecesWithMultipleVariants
                  || isRequirementsExist && !isRequirementsFilled
                  && requirementsFilling.printingPictures[addOn.id] === undefined"
      [active]="(cartLine.variant || isPiecesWithMultipleVariants)
                && requirementsFilling.printingPictures[addOn.id] === false"
      [printingPicture]="addOn"
      [disabledChooseMotiveModal]="disabledChooseMotiveModal"
      [activePrinting]="printingPictureMap[addOn.id]"
      [currency]="currency"
      (onSelect)="onPrintingPictureSelected.emit({ addOn: addOn, printingPicture: $event })"
    ></cake-motive-section>
  </ng-container>

  <ng-container *ngIf="addOn.addonType === ADDONS_TYPES.EXTRA_PRODUCT">
    <yes-no-add-on-section
      *ngIf="addOn.type === 'YES_NO' else general"
      class="border-for-build-section"
      [group]="addOn"
      [disabled]="disabled"
      [currency]="currency"
      [selectedProducts]="cartLine.extraProductsMap[addOn.id]"
      (onSelect)="onExtraProductSelected.emit({ products: $event, groupId: addOn.id })"
      [products]="addOn.items">
    </yes-no-add-on-section>

    <ng-template #general>
      <cake-extra-products-section
        class="border-for-build-section"
        [disabled]="disabled"
        [products]="addOn.items"
        [group]="addOn"
        [selectedProducts]="cartLine.extraProductsMap[addOn.id]"
        [currency]="currency"
        (onSelect)="onExtraProductSelected.emit({ products: $event, groupId: addOn.id })"
      ></cake-extra-products-section>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="addOn.addonType === ADDONS_TYPES.QUESTION">
    <cake-question-section
      class="border-for-build-section"
      [disabled]="disabled"
      [question]="cartLine.questionsMap[addOn.id].questionText"
      [answer]="cartLine.questionsMap[addOn.id].answer"
      [helpText]="cartLine.questionsMap[addOn.id].helpText"
      [maxLength]="resolveMaxLength(addOn)"
      [price]="cartLine.questionsMap[addOn.id].price"
      [currency]="currency"
      (onChange)="onQuestionAnswerChange.emit({ answer: $event, question: cartLine.questionsMap[addOn.id] })"
    ></cake-question-section>
  </ng-container>

  <ng-container *ngIf="addOn.addonType === ADDONS_TYPES.DEPOSIT">
    <product-deposit-section
      *ngFor="let deposit of deposits"
      class="border-for-build-section"
      [disabled]="disabled"
      [currency]="currency"
      [deposit]="deposit"
    ></product-deposit-section>
  </ng-container>
</ng-container>
